import { useMemo } from "react";

import { AuthApi } from "@/apis/connect/auth-api";
import { CompanyApi } from "@/apis/connect/company-api";
import { GroupApi } from "@/apis/connect/group-api";
import { ImageApi } from "@/apis/connect/image-api";
import { PartnerApi } from "@/apis/connect/partner-api";
import { ProjectApi } from "@/apis/connect/project-api";
import { TaskApi } from "@/apis/connect/task-api";
import { UsageReportApi } from "@/apis/connect/usage-report-api";
import { WorkspaceApi } from "@/apis/connect/workspace-api";
import { WorkspaceUserApi } from "@/apis/connect/workspace-user-api";

import { authTokenInfoAtom } from "@/global-states/common-atoms";
import { useAtom } from "jotai";

export const useApiConnector = () => {
  const [authTokenInfo] = useAtom(authTokenInfoAtom);

  const appAuthApi = useMemo(() => new AuthApi(authTokenInfo?.access_token), [authTokenInfo]);
  const appCompanyApi = useMemo(() => new CompanyApi(authTokenInfo?.access_token), [authTokenInfo]);
  const appPartnerApi = useMemo(() => new PartnerApi(authTokenInfo?.access_token), [authTokenInfo]);
  const appImageApi = useMemo(() => new ImageApi(authTokenInfo?.access_token), [authTokenInfo]);
  const appUsageReportApi = useMemo(() => new UsageReportApi(authTokenInfo?.access_token), [authTokenInfo]);
  const workspaceApi = useMemo(() => new WorkspaceApi(authTokenInfo?.access_token), [authTokenInfo]);
  const workspaceUserApi = useMemo(() => new WorkspaceUserApi(authTokenInfo?.access_token), [authTokenInfo]);
  const taskApi = useMemo(() => new TaskApi(authTokenInfo?.access_token), [authTokenInfo]);
  const groupApi = useMemo(() => new GroupApi(authTokenInfo?.access_token), [authTokenInfo]);
  const projectApi = useMemo(() => new ProjectApi(authTokenInfo?.access_token), [authTokenInfo]);
  return {
    appAuthApi,
    appCompanyApi,
    appPartnerApi,
    appImageApi,
    appUsageReportApi,
    workspaceApi,
    workspaceUserApi,
    taskApi,
    groupApi,
    projectApi,
  };
};
